import React from "react";
import { Typography, Box } from "@mui/material";
import styles from "./ValueWithLabel.module.css";
type ValueWithLabelProps = {
  label: string;
  value: string | React.ReactNode;
  extradetails?: string;
  width?: number;
};
export const ValueWithLabel: React.FC<ValueWithLabelProps> = (props) => {
  const width = props.width ? props.width : 800;
  return (
    <Box display={"flex"} width={`${width}px`} justifyContent={"flex-start"}>
      <Typography display={"inline"} className={`${styles.labelText}`} variant={"body1"}>
        {" "}
        {props.label}
      </Typography>
      <Box display={"inline"}>
        <Typography display={"inline"} className={`${styles.valueText}`} variant={"body1"}>
          {" "}
          {props.value}
        </Typography>
        {props.extradetails && (
          <Typography display={"inline"} className={`${styles.valueExtraDetails}`} variant={"body1"}>
            {" "}
            {props.extradetails}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
